import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroBanner from './components/HeroBanner';
import FeaturedMovies from './components/FeaturedMovies';
import CategorySection from './components/CategorySection';
import LatestUpdates from './components/LatestUpdates';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '夜猫电影院',
  url: 'https://www.nightowlcinema.com',
  description: '夜猫电影院提供高清电影免费在线观看，免费电视剧全集不卡顿，高清画质秒播，熬夜追剧不缓冲，免费影院一网打尽。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.nightowlcinema.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
  inLanguage: 'zh-CN',
};

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
      <div className="min-h-screen bg-background-950">
        <Navbar />
        <main>
          <HeroBanner />
          <FeaturedMovies />
          <CategorySection />
          <LatestUpdates />
        </main>
        <Footer />
      </div>
    </>
  );
}